/**
 * 资产是否超出限制
 * TODO: 完善资产限制逻辑
 * 1. 新建场景，list禁用可用数量<=0的资产，提交有资产数量校验
 * 2. 复制场景，list禁用可用数量<复制数量的资产，提交有资产数量校验
 * 3. 编辑场景，list禁用非当前资产&&可用数量<=0 的资产，提交无资产数量校验
 * @param assetId
 * @param availableNumber
 * @returns
 */
export const isAssetExceedLimit = (assetId, availableNumber = 1000) => {
  let isAssetLimit = false;
  // if (this.isCreate) {
  isAssetLimit = availableNumber <= 0;
  // }
  // else if (this.isCopy) {
  //   isAssetLimit = this.adgroup?.copyNumber > availableNumber;
  // }
  return isAssetLimit;
};
